<template>
  <div class="logo-container">
    <el-image
      :src="logo" class="image">
    </el-image>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'
export default {
  name: 'logo',
  data () {
    return {
      logo
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-container {
  text-align: center;
  .image {
    width: 80px;
    vertical-align: middle;
  }
  // position: absolute;
  width: 100%;
  height: 100%;
  // bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/logo/index.vue